import { primaryButtonClick } from "#skyward_browse";
import { virtualDir } from "#skyward_global";
import { ButtonDefinition, ButtonIcon, ButtonText, showDialog } from "#skyward_modalLayer";
import { loadContent } from "#skyward_window";
import { registerEvents } from "./skyward.ui.events";
import { JQueryInput } from "./types";

const classNames =
{
    tileRedirectButton: "tileRedirectButton",
    dailyAttendanceTileFooter: "dailyAttendanceTileFooter",
    dailyAttendanceMarkPresentButton: "dailyAttendanceMarkPresentButton",
    dailyAttendanceTakenButton: "dailyAttendanceTakenButton",
    processing: "processing",
    anchorText: "anchorText",
    svg: "svg",
    tileBrowseIgnoreTileClick: "tileBrowseIgnoreTileClick"
};

const events =
{
    init
};

registerEvents("tileBrowse", events);

function init(selector: JQueryInput)
{
    const tile = $(selector);
    const tileData = tile.data();
    if ($.isEmptyObject(tileData))
    {
        return;
    }

    setupClickEvent(tile);

    const tileMarkPresentButton = tile.parent().find(`.${classNames.dailyAttendanceTileFooter} .${classNames.dailyAttendanceMarkPresentButton}`);
    const courseGrouping = $('#TeacherAccessGrouping').val();

    if (tileMarkPresentButton.length)
    {
        let markAllPresentEnabled = false;

        if ($('#ConfirmPerfectAttendance').length)
        {
            markAllPresentEnabled = $('#ConfirmPerfectAttendance').val()?.toString().toLowerCase() === "true";
        }

        function markStudentsPresentAjax()
        {
            const footerContainer = tileMarkPresentButton.parent();
            const footerContainerId = footerContainer.attr('id') ?? "";

            tileMarkPresentButton.addClass(classNames.processing);
            const processingColor = "#B0B0B0";

            const buttonText = tileMarkPresentButton.find(`.${classNames.anchorText}`);
            buttonText.text("Taking Attendance...");
            buttonText.css("color", processingColor);

            const buttonSvg = tileMarkPresentButton.find(`.${classNames.svg}`);
            buttonSvg.css("fill", processingColor);

            $.when(loadContent(footerContainerId, 'Attendance', 'DailyAttendance', 'MarkStudentsPresent', tileData.defaultrowkey, { CourseGrouping: courseGrouping })).done(function ()
            {
                tileMarkPresentButton.remove();
                const newButton = footerContainer.find(`.${classNames.dailyAttendanceTakenButton}`);
                if (newButton.length)
                {
                    newButton.one("click", function (event)
                    {
                        primaryButtonClick(tileData.browseid, tileData.tilenumber, tileData.target, tileData.module, tileData.object, tileData.screen, tileData.defaultrowkey, null, tileData.postdata, event, false);
                    });
                }
            }).fail(function (error)
            {
                const options = { id: "options" };
                const closeButton: ButtonDefinition = { id: "closeButton", text: ButtonText.Close, icon: ButtonIcon.Close, click: function () { dialog.close(); } };
                const dialog = showDialog('Error', error, [closeButton], options);
            });
        };

        function markPresentButtonFunction()
        {
            if (markAllPresentEnabled)
            {
                $.ajax({
                    url: `${virtualDir}Attendance/DailyAttendance/GetNumberOfOfficeAbsences/${tileData.defaultrowkey}`,
                    method: 'POST',
                    data: { CourseGrouping: courseGrouping },
                    success: function (data)
                    {
                        if (data.isPerfectAttendance)
                        {
                            const saveButton: ButtonDefinition =
                            {
                                id: "confirmPerfectAttendance",
                                text: "Yes, Confirm",
                                click: function ()
                                {
                                    markStudentsPresentAjax();
                                    dialog.close();
                                },
                                icon: ButtonIcon.Check
                            };
                            const cancelButton: ButtonDefinition =
                            {
                                id: "cancelPerfectAttendance",
                                text: "No, Cancel",
                                click: function ()
                                {
                                    tileMarkPresentButton.one("click", markPresentButtonFunction);
                                    dialog.close();
                                },
                                icon: ButtonIcon.Cancel
                            };
                            const options =
                            {
                                id: "confirmPerfectAttendancePopup",
                                width: 550,
                                closeOnClick: false,
                                closeOnEscape: false,
                            };
                            const dialog = showDialog("Confirm Perfect Attendance", "Are you sure you want to confirm Perfect Attendance?", [saveButton, cancelButton], options);
                        }
                        else
                        {
                            markStudentsPresentAjax();
                        }
                    }
                });
            }
            else
            {
                markStudentsPresentAjax();
            }
        };

        tileMarkPresentButton.one("click", markPresentButtonFunction);
    }
}

export function setupClickEvent(tile: JQuery<HTMLElement>)
{
    const tileButtonData = tile.data();
    tile.one("click", function (event)
    {
        if (event.target && $(event.target).hasClass(classNames.tileBrowseIgnoreTileClick))
        {
            setupClickEvent(tile);
            return;
        }
        primaryButtonClick(tileButtonData.browseid, tileButtonData.tilenumber, tileButtonData.target, tileButtonData.module, tileButtonData.object, tileButtonData.screen, tileButtonData.defaultrowkey, null, tileButtonData.postdata, event, false);
    });
}
